module.exports = __webpack_public_path__ + "811399b6fb6959660c4721cb403e12ad.svg";